import {
  FaLayerGroup,
  FaMapMarkerAlt,
  FaStar,
  FaMoneyBillWave,
  FaMagic,
} from "react-icons/fa";
import uspman from "../../../assets/images/uspMan.png";

const UniqueUsp = () => {
  return (
    <section className="usp" data-aos="fade-up">
      <div className="container">
        {/* Heading */}
        <div className="row mb-4">
          <div className="col-md-12 text-center">
            <h6 className="subtitle">USP</h6>
            <h2 className="display-5 fw-bold">Why We Are Unique (USP)</h2>
          </div>
        </div>

        <div className="row align-items-center">
          {/* Left Column */}
          <div className="col-md-4 col-sm-12">
            <div className="wc-box">
              <div className="fs-1">
                <FaLayerGroup />
              </div>
              <div className="wc-box-in">
                <h3>All-in-One Ecosystem</h3>
                <p>Services, riders, and products in one unified app</p>
              </div>
            </div>

            <div className="wc-box">
              <div className="fs-1">
                <FaMapMarkerAlt />
              </div>
              <div className="wc-box-in">
                <h3>Live Tracking</h3>
                <p>Fast bookings powered by real-time location tracking</p>
              </div>
            </div>

            <div className="wc-box">
              <div className="fs-1">
                <FaStar />
              </div>
              <div className="wc-box-in">
                <h3>Transparent Ratings</h3>
                <p>Built on safety, speed, and quality feedback</p>
              </div>
            </div>
          </div>

          {/* Center Image */}
          <div className="col-md-4 wc-cen text-center">
            <img src={uspman} alt="usp man signal" className="img-fluid" />
          </div>

          {/* Right Column */}
          <div className="col-md-4 col-sm-12">
            <div className="wc-box">
              <div className="fs-1">
                <FaMoneyBillWave />
              </div>
              <div className="wc-box-in">
                <h3>Dual Income Model</h3>
                <p>Sustainable earnings from services and product sales</p>
              </div>
            </div>

            <div className="wc-box">
              <div className="fs-1">
                <FaMagic />
              </div>
              <div className="wc-box-in">
                <h3>Simplicity</h3>
                <p>Easy-to-use experience for every type of user</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueUsp;
